import { call, put, takeLatest } from 'redux-saga/effects';
import { Apis } from 'src/services/api';
import {
  addEmployeeAsync,
  getEmployeesAsync,
  getVacantEmployeesAsync,
  setSelectedEmployee,
  updateEmployeeAsync,
  exportCSVEmployeesAsync,
} from './actions';
import { EmployeeInfo } from './types';
import FileSaver from 'file-saver';

function* getEmployees(api, action) {
  try {
    const employees = yield call(api, action.payload);
    yield put(getEmployeesAsync.success(employees.data));
  } catch (err) {
    yield put(getEmployeesAsync.failure(err));
  }
}

function* getVacantEmployees(api, action) {
  try {
    const employees = yield call(api, action.payload);

    if (action.payload.callback) {
      action.payload.callback(employees.data);
    }
    yield put(getVacantEmployeesAsync.success(employees.data));
  } catch (err) {
    yield put(getVacantEmployeesAsync.failure(err));
  }
}

function* updateEmployee(api, action) {
  try {
    const res = yield call(api, action.payload);
    if (res?.ok) {
      yield put(updateEmployeeAsync.success(res));
      yield put(setSelectedEmployee(res.data as EmployeeInfo));
    } else yield put(updateEmployeeAsync.failure(res));
  } catch (err) {
    yield put(addEmployeeAsync.failure(err));
  }
}

function* addEmployee(api, action) {
  try {
    const res = yield call(api, action.payload);
    if (res?.ok) yield put(addEmployeeAsync.success(res));
    else yield put(addEmployeeAsync.failure(res));
  } catch (err) {
    yield put(addEmployeeAsync.failure(err));
  }
}

function* exportCSVEmployees(api: Apis['exportCSVEmployees']) {
  try {
    const res = yield call(api);
    if (res?.ok) {
      const csvData = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
      const fileName = `Employees.csv`;
      FileSaver.saveAs(csvData, fileName);

      yield put(exportCSVEmployeesAsync.success());
    } else yield put(exportCSVEmployeesAsync.failure(res));
  } catch (err) {
    yield put(exportCSVEmployeesAsync.failure(err));
  }
}

export default function employeesSaga(apiInstance: Apis) {
  return [
    takeLatest(getEmployeesAsync.request, getEmployees, apiInstance.getEmployees),
    takeLatest(getVacantEmployeesAsync.request, getVacantEmployees, apiInstance.getVacantEmployees),
    takeLatest(updateEmployeeAsync.request, updateEmployee, apiInstance.updateEmployee),
    takeLatest(addEmployeeAsync.request, addEmployee, apiInstance.addEmployee),
    takeLatest(exportCSVEmployeesAsync.request, exportCSVEmployees, apiInstance.exportCSVEmployees),
  ];
}
